const translationKey = ({ domain, locale }) => `${domain}.i18n.${locale}`;
export { translationKey };
